<template>
  <img
    class="ml-5 rounded-full cursor-pointer h-10 aspect-square border-2 border-transparent hover:border-blue-400 object-cover"
    :src="(user.avatar ?? assetImagePlaceholder)+'?size=64x64'"
    >
</template>

<script setup lang="ts">
import assetImagePlaceholder from '~/assets/img/placeholder-user.png'
</script>
